import React from "react";
import classNames from "classnames";

import MultilineText from "../../MultilineText";
import DisplayField from "../DisplayField";
import styles from "./DeliveryEvent.css";
import ActionButtons from "./ActionButtons";
import Details from "./Details";
import Materials from "./Materials";

const makeStyle = ({ color }) =>
  !color
    ? null
    : {
        borderColor: color,
      };

const getEntityActive = (event, entity) => {
  if (event.job) {
    return entity === "jobs";
  }
  if (event.purchaseOrder || event.inventoryPurchaseOrder) {
    return entity === "purchaseOrders";
  }
  return false;
};

const DeliveryEvent = ({
  className,
  detailEnabled,
  entity,
  event,
  financialEnabled,
  locationEnabled,
  materialEnabled,
  onClick,
  onDeleteEventClick,
  onEditEventClick,
  onOpenClick,
  showActions,
  styleSelector,
}) => {
  const purchaseOrder = event.purchaseOrder || event.inventoryPurchaseOrder;
  return (
    <div
      className={classNames(className || styles.container, {
        [styles.inactive]: !getEntityActive(event, entity),
      })}
      style={
        typeof styleSelector === "function"
          ? styleSelector(event)
          : makeStyle(event)
      }
    >
      <div onDoubleClick={onClick}>
        <div
          style={
            typeof styleSelector === "function"
              ? styleSelector(event)
              : makeStyle(event)
          }
        >
          <h5
            style={{
              textAlign: "left",
              padding: "6px 8px",
              fontSize: "16px",
              fontFamily: "var(--font-family-Fira-Condensed)",
            }}
          >
            <b>{`${purchaseOrder.poNumber} - ${purchaseOrder.name || ""}`}</b>
          </h5>
        </div>
        <div className={styles.deliveryEventHeader}>
          {detailEnabled && (
            <DisplayField group="details" field="description">
              <MultilineText text={event.description} />
            </DisplayField>
          )}

          {detailEnabled && <Details event={event} />}

          {materialEnabled && <Materials event={event} styles={styles} />}

          {locationEnabled && purchaseOrder.shipTo && (
            <DisplayField group="location" field="deliveryShipTo">
              <MultilineText text={purchaseOrder.shipTo} />
            </DisplayField>
          )}
        </div>
      </div>
      {showActions && (
        <ActionButtons
          onDeleteEventClick={onDeleteEventClick}
          onEditEventClick={onEditEventClick}
          onOpenClick={onOpenClick}
        />
      )}
    </div>
  );
};

DeliveryEvent.defaultProps = {
  showActions: true,
};

export default DeliveryEvent;
